export default __webpack_public_path__ + "static/media/intro-result.1491f41b.png";